import { z } from 'zod';

const quoteStatusSchema = z.enum(['DRAFT', 'SENT', 'APPROVED', 'DECLINED', 'EXPIRED']);
export const quoteSchema = z.object({
  id: z.string().uuid(),
  quoteNumber: z.number().int(),
  status: quoteStatusSchema,
  totalAmount: z.string(),
  validUntil: z.string(),
  createdAt: z.string(),
  taskId: z.string().uuid().nullable(),
  remindersSent: z.number().int(),
  nextReminderAt: z.string().nullable(),
  remindersPaused: z.boolean(),
  customer: z.object({ id: z.string().uuid(), name: z.string() }),
  lines: z.array(z.object({ description: z.string(), amount: z.string(), qty: z.number().int().default(1) })),
  /** הנחה על כל ההצעה. totalAmount כבר אחרי ההנחה (ולפני מע"מ). */
  discountType: z.enum(['PERCENT', 'AMOUNT']).nullish(),
  discountValue: z.string().nullish(),
  discountAmount: z.string().nullish(),
  discountLabel: z.string().nullish(),
  vatMode: z.enum(['added', 'included', 'exempt']).nullish(),
  vatRate: z.string().nullish(),
  signerName: z.string().nullish(),
  signedAt: z.string().nullish(),
  /** מה תוכנית העבודה פתחה אחרי החתימה (QuoteWorkPlanService). */
  workPlan: z
    .object({
      complexity: z.enum(['simple', 'complex']),
      tasks: z.number(),
      admin: z.number(),
      scheduled: z.number(),
      visits: z.number(),
      firstVisit: z.object({ userName: z.string(), start: z.string() }).nullable(),
    })
    .nullish()
    .catch(null),
});
export type Quote = z.infer<typeof quoteSchema>;

/** הסכום שהלקוח רואה — כולל מע"מ כשהמחירון לפניו. הצעה ישנה (בלי vatMode) — כפי שנשלחה. */
export function quoteGross(q: Pick<Quote, 'totalAmount' | 'vatMode' | 'vatRate'>): number {
  const net = Math.round(Number(q.totalAmount) * 100);
  if (q.vatMode !== 'added') return net / 100;
  return (net + Math.round((net * Number(q.vatRate ?? 0)) / 100)) / 100;
}
